import PageShoplist from '@/pages/PageShoplist'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageShoplist
	}

	let page = vuewidget(dom, options)
	return page
}